import { useMemo, useState } from "react";
import {
  List,
  NumberField,
  TextField,
  WrapperField,
  DatagridConfigurable,
  WithRecord,
  DateField,
  usePermissions,
} from "react-admin";
import SalesmanIncentiveRateRuleAddDialog from "../../components/salesmanIncentiveRateRules/create/SalesmanIncentiveRateRuleAddDialog";
import SalesmanIncentiveRateRuleEditDialog from "../../components/salesmanIncentiveRateRules/edit/SalesmanIncentiveRateRuleEditDialog";
import EditBtn from "../../components/editBtn/EditBtn";
import TableListActions from "../../components/tableListActions/TableListActions";

const SalesmanIncentiveRateRuleList = () => {
  const { permissions } = usePermissions();
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [recordId, setRecordId] = useState();

  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };
  const handleClickOpenEdit = (recId) => () => {
    setRecordId(recId);
    setOpenEdit(true);
  };

  const list = useMemo(
    () => (
      <List
        empty={false}
        actions={
          <TableListActions
            createHandler={handleClickOpenAdd}
            exporter={false}
            filter={false}
            createPermission="create_salesman_incentive_rate_rule"
          />
        }
        queryOptions={{ meta: { sort: ["created_at DESC"] } }}
      >
        <DatagridConfigurable bulkActionButtons={false}>
          <NumberField source="_position" label="#" sortable={false} />
          {permissions && permissions.update_company ? (
            <TextField label="mine.label.company" source="company.alias" />
          ) : null}
          <NumberField
            label="Minimum Sale Net"
            source="min_sale_net"
            options={{
              style: "decimal",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }}
          />
          <NumberField
            label="Maximum Sale Net"
            source="max_sale_net"
            options={{
              style: "decimal",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }}
          />
          <NumberField
            label="Rate G"
            source="rate_g"
            options={{
              style: "percent",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }}
          />
          <NumberField
            label="Rate PHM"
            source="rate_phm"
            options={{
              style: "percent",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }}
          />
          <NumberField
            label="Rate Z"
            source="rate_z"
            options={{
              style: "percent",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }}
          />
          <DateField
            source="valid_from"
            label="Valid From"
            options={{ year: "numeric", month: "short", day: "2-digit" }}
          />
          <DateField
            source="valid_to"
            label="Valid To"
            options={{ year: "numeric", month: "short", day: "2-digit" }}
          />
          <WrapperField label="mine.label.actions" textAlign="center">
            <WithRecord
              label="author"
              render={(record) => {
                return <EditBtn editHandler={handleClickOpenEdit(record.id)} />;
              }}
            />
          </WrapperField>
        </DatagridConfigurable>
      </List>
    ),
    [permissions]
  );

  return (
    <>
      {list}
      <SalesmanIncentiveRateRuleAddDialog open={openAdd} setOpen={setOpenAdd} />
      <SalesmanIncentiveRateRuleEditDialog
        open={openEdit}
        setOpen={setOpenEdit}
        recordId={recordId}
      />
    </>
  );
};

export default SalesmanIncentiveRateRuleList;
